/**
 * Ready-made mutation documents. Input types and field names match `schema.graphql`.
 */

const SUBMIT_FORM = /* GraphQL */ `
	mutation SubmitForm($input: SubmitFormInput!) {
		submitForm(input: $input) {
			ok
			leadId
			deduplicated
			message
		}
	}
`;

const SUBSCRIBE_NEWSLETTER = /* GraphQL */ `
	mutation SubscribeNewsletter($input: NewsletterSubscribeInput!) {
		subscribeNewsletter(input: $input) {
			ok
			leadId
			deduplicated
			message
		}
	}
`;

const REQUEST_RESOURCE_DOWNLOAD = /* GraphQL */ `
	mutation RequestResourceDownload($input: RequestResourceDownloadInput!) {
		requestResourceDownload(input: $input) {
			ok
			signedUrl
			leadId
		}
	}
`;

const SAVE_PREFERENCES = /* GraphQL */ `
	mutation SavePreferences($input: SavePreferencesInput!) {
		savePreferences(input: $input) {
			ok
		}
	}
`;

/** All ready-made mutation documents, keyed by name. */
export const mutations = {
	SUBMIT_FORM,
	SUBSCRIBE_NEWSLETTER,
	REQUEST_RESOURCE_DOWNLOAD,
	SAVE_PREFERENCES,
} as const;

/** Union of available mutation names in {@link mutations}. */
export type MutationName = keyof typeof mutations;
